import React from 'react'
import Calendar from './Calendar'
import Select from '../Select'
import axios from "axios/index"

export default class CalendarLayout extends React.Component {

    constructor(props) {
        super(props)
        axios.defaults.headers.common['Accept'] = 'application/json'
        //p_id: 2, pl_id: 11, plg_id: 21
        this.state = {p_id: null, pl_id: null, plg_id: null, locations: [], groups: [], offers: {requests: [], specials: []}, loading_locations: false,
        loading_groups: false, loading_offers: false}
    }

    selectProvider = (p_id) => {
        this.setState({p_id: p_id, loading_locations: !!p_id, pl_id: null, plg_id: null, locations: [], groups: [], offers: []})
        if(!p_id) return
        axios.get(`/admin/provider/rental_calendars/locations?provider_id=${p_id}`)
            .then(res => this.setState({...res.data, loading_locations: false}))
    }

    selectLocation = (pl_id) => {
        this.setState({pl_id: pl_id, loading_groups: !!pl_id, plg_id: null, groups: [], offers: []})
        if(!pl_id) return
        axios.get(`/admin/provider/rental_calendars/groups?provider_location_id=${pl_id}`)
            .then(res => this.setState({...res.data, loading_groups: false}))
    }


    selectGroup = (plg_id) => {
        this.setState({plg_id: plg_id, loading_offers: !!plg_id, offers: []})
        if(!plg_id) return
        axios.get(`/admin/provider/rental_calendars/offers?provider_location_group_id=${plg_id}`)
            .then(res => this.setState({...res.data, loading_offers: false}))
    }

    componentDidMount = () => {
        // this.selectGroup(21)
    }

    render() {
        return(
            <div>
                <div className={'row'}>
                    <div className={'col'}>
                    <Select carModels={this.props.providers} handleChange={this.selectProvider}/>
                    </div>
                    <div className={'col'}>
                        {this.state.p_id && !this.state.loading_locations &&
                            <Select carModels={this.state.locations} handleChange={this.selectLocation}/>
                        }
                    </div>
                    <div className={'col'}>
                        {this.state.pl_id && !this.state.loading_groups && !this.state.loading_locations &&
                            <Select carModels={this.state.groups} handleChange={this.selectGroup}/>
                        }
                    </div>
                    {this.state.pl_id &&
                    <div>
                        <a href={`/admin/provider/rental_offers?provider_location_id=${this.state.pl_id}`}>Vezi ca tabel</a>
                    </div>
                    }
                </div>
                {this.state.plg_id && !this.state.loading_groups && !this.state.loading_locations && !this.state.loading_offers &&
                <Calendar
                    offers={this.state.offers}
                    plg_id={this.state.plg_id}
                    reload={() => this.selectGroup(this.state.plg_id)}
                    baseUrl={'/admin/provider'}
                    admin={true}
                />
                }
            </div>
        )
    }
}